import { render } from "./room-details.vue?vue&type=template&id=17c0833b&scoped=true&lang=pug"
import script from "./room-details.vue?vue&type=script&lang=js"
export * from "./room-details.vue?vue&type=script&lang=js"

import "./room-details.vue?vue&type=style&index=0&id=17c0833b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c0833b"]])

export default __exports__